$(document).ready(() => {

    $(document).on('click', '#form-comment button[type="submit"]', function () {
        $(this).addClass('disabled');
    });

    $('#form-comment').on('submit', function () {
        $(this).find('button[type="submit"]').removeClass('disabled');
    });

    $(document).on('click', '.settings-icon', function () {
        console.log($(this).data('setting'));
        $('.settings-comment.active').removeClass('active');
        $('.settings-comment[data-setting="' + $(this).data('setting') + '"]').addClass('active');
    });

    let initComments = () => {

        let $cancel_reply = $('#cancel-reply');
        let $cancel_edit = $('#cancel-edit');
        let $reply_to = $('input[name="reply_to"]');
        let $edit_to = $('input[name="edit_to"]');
        let $delete_to = $('input[name="delete_to"]');

        let editMode = ($article) => {
            $('#form-comment').attr('action', $('#form-comment').data('urledit') + '/' + $article.data('comment'));
            $('#textarea-comment').val($article.find('p.comment-content').html());
            $('#btn-post').hide();
            $('#btn-edit').show();
            $cancel_edit.show();
            $cancel_reply.hide();
        };

        let commentMode = () => {
            $('#form-comment').attr('action', $('#form-comment').data('urlcomment'));
            $('#textarea-comment').val('');
            $('#btn-post').show();
            $cancel_edit.hide();
            $('#btn-edit').hide();
        };


        $cancel_reply.on('click', function()  {
            $(this).hide();
            $reply_to.val('');
        });

        $cancel_edit.on('click', function()  {
            $(this).hide();
            $edit_to.val('');
            commentMode();

        });

        $('.btn-reply').on('click', function () {
            $reply_to.val($(this).data('comment'));
            commentMode();
            $cancel_reply.show();
            $([document.documentElement, document.body]).animate({
                scrollTop: $('#form-comment').offset().top
            }, 500);
        });

        $('.btn-edit').on('click', function () {
            let $article = $(this).closest('article');
            $edit_to.val($article.data('comment'));
            editMode($article);
            $([document.documentElement, document.body]).animate({
                scrollTop: $('#form-comment').offset().top
            }, 500);
        });

        $('.btn-delete').on('click', function () {
            let $article = $(this).closest('article');
            let $commentId = $article.data('comment');
            if(confirm('Are you sure you want to delete the comment?')){
                $('#form-comment').attr('action', $('#form-comment').data('urldelete') + '/' + $commentId);
                $('#form-comment').trigger('submit');
            }
        });


        let on200 = (res) => {
            $('#comments').html(res.html);
            initComments();
            if(res.comment){
                $([document.documentElement, document.body]).animate({
                    scrollTop: $('article[data-comment="'+res.comment+'"]').offset().top - 65
                }, 1500);
            }
        };

        let on400 = (res) => {
            $('#comments').html(res.responseJSON.html);
            initComments();
        };

        let $form = $('#form-comment');
        $form.on('submit', function (evt) {
            evt.preventDefault();
            ajaxSubmitForm($form, on200, on400);
        });

    };

    $('#btn-upvote').on('click', function () {
        if($(this).data('enabled')){
            $.ajax({
                url: $(this).data('url'),
                type: 'post',
                dataType: 'json',
                statusCode: {
                    200: (res) => {
                        $(this).find('span').html(res.upvotes);
                        $(this).attr('disabled', 'disabled');
                    },
                    400: (res) => {window.location.reload()}
                }
            })
        }else{
            $('#login-to-upvote').show()
        }

    });

    $('#btn-show-comments').on('click', function () {
       $.ajax({
           url: $(this).data('url'),
           dataType: 'json',
           statusCode: {
               200: (res) => {
                   $(this).remove();
                   $('#comments').html(res.html);
                   initComments();
               },
               400: (res) => {console.error(res.responseJSON.error)}
           }
       });
    });

    $('#category-selector').on('change', function () {
       let url = $(this).data('url');
       url += '/';
       url += $(this).val();
       window.location.assign(url);
    });

    $('#li-share').attr('href', 'http://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(location.href));
    $('#fb-share').attr('href', 'http://www.facebook.com/share.php?u=' + encodeURIComponent(location.href));
    $('#tw-share').attr('href', 'http://www.twitter.com/share?url=' + encodeURIComponent(location.href));


    // Search Filter
    $('#search-filter').click(function () {
        $(this).toggleClass('active');
        $('.news-hero .filter-container').toggleClass('active');
    });

    $('#close-filter').click(function () {
        $('#search-filter').removeClass('active');
        $('.news-hero .filter-container').removeClass('active');
    });

    // Add article to favorites
    $('#add-article-favorite').click(function () {

        let articleId = $(this).data('article-id');
        let favorited = '';

        if ($(this).hasClass('favorited')) {
            favorited = 'off';
            $(this).attr('title', 'Add to favorites');
            $(this).removeClass('favorited');
        } else {
            favorited = 'on';
            $(this).attr('title', 'Remove from favorites');
            $(this).addClass('favorited');
        }

        $.ajax({
            url  : '/news-and-articles/favorite/' + articleId,
            type : 'POST',
            data : {favorite: favorited},
            success : function(result) {
                console.log(result);
            },
            error : function (xhr) {
                console.log(xhr.responseJSON);
            }
        });
    });
});